import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';

export function RealAssetFields() {
  return (
    <>
      <MetaControlField attr={'name'} />
      <MetaControlField attr={'type'} />
      <MetaControlField attr={'subType'} />
      <MetaControlField attr={'ownerClientId'} />
      <MetaControlField attr={'value'} flexGrow={1} {...dataAttrs('real-asset-value')} />

      <MetaLayoutRemainingFields />
    </>
  );
}
